export const SET_USER_PREFERENCES = `
  mutation setUserPreference($userId: ID!, $input: UserPreferencesInput) {
    setUserPreference(userId: $userId, input: $input) {
      preferredName
      preferredLanguage
      status {
        message
        type
      }
    }
  }
`;
